import { Tooltip as TooltipPrimitive } from "@base-ui/react/tooltip";
import { Z_INDEX_CLASS_NAMES } from "@/configs/z-index";
import { cn } from "@/utils/class-name";

const TooltipCreateHandle = TooltipPrimitive.createHandle;
const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
function TooltipTrigger(props: TooltipPrimitive.Trigger.Props) {
    return <TooltipPrimitive.Trigger data-slot={"tooltip-trigger"} {...props} />;
}
function TooltipPopup({
    className,
    align = "center",
    alignOffset = 0,
    sideOffset = 4,
    side = "top",
    anchor,
    children,
    ...props
}: TooltipPrimitive.Popup.Props & {
    align?: TooltipPrimitive.Positioner.Props["align"];
    alignOffset?: TooltipPrimitive.Positioner.Props["alignOffset"];
    side?: TooltipPrimitive.Positioner.Props["side"];
    sideOffset?: TooltipPrimitive.Positioner.Props["sideOffset"];
    anchor?: TooltipPrimitive.Positioner.Props["anchor"];
}) {
    return (
        <TooltipPrimitive.Portal>
            <TooltipPrimitive.Positioner
                align={align}
                alignOffset={alignOffset}
                anchor={anchor}
                className={cn(
                    Z_INDEX_CLASS_NAMES.TOOLTIP,
                    "h-(--positioner-height) w-(--positioner-width) max-w-(--available-width) transition-[top,left,right,bottom,transform] data-instant:transition-none",
                )}
                data-slot={"tooltip-positioner"}
                side={side}
                sideOffset={sideOffset}
            >
                <TooltipPrimitive.Popup
                    className={cn(
                        "relative flex h-(--popup-height,auto) w-(--popup-width,auto) origin-(--transform-origin) text-balance rounded-md border bg-popover not-dark:bg-clip-padding text-popover-foreground text-xs shadow-md/5 transition-[width,height,scale,opacity] before:pointer-events-none before:absolute before:inset-0 before:rounded-[calc(var(--radius-md)-1px)] before:shadow-[0_1px_--theme(--color-black/4%)] data-ending-style:scale-98 data-starting-style:scale-98 data-ending-style:opacity-0 data-starting-style:opacity-0 data-instant:duration-0 dark:before:shadow-[0_-1px_--theme(--color-white/6%)]",
                        className,
                    )}
                    data-slot={"tooltip-popup"}
                    {...props}
                >
                    <TooltipPrimitive.Viewport
                        className={
                            "relative size-full overflow-clip px-(--viewport-inline-padding) py-1 [--viewport-inline-padding:--spacing(2)] data-instant:transition-none **:data-current:data-ending-style:opacity-0 **:data-current:data-starting-style:opacity-0 **:data-previous:data-ending-style:opacity-0 **:data-previous:data-starting-style:opacity-0 **:data-current:w-[calc(var(--popup-width)-2*var(--viewport-inline-padding)-2px)] **:data-previous:w-[calc(var(--popup-width)-2*var(--viewport-inline-padding)-2px)] **:data-previous:truncate **:data-current:opacity-100 **:data-previous:opacity-100 **:data-current:transition-opacity **:data-previous:transition-opacity"
                        }
                        data-slot={"tooltip-viewport"}
                    >
                        {children}
                    </TooltipPrimitive.Viewport>
                </TooltipPrimitive.Popup>
            </TooltipPrimitive.Positioner>
        </TooltipPrimitive.Portal>
    );
}
export {
    TooltipCreateHandle,
    TooltipProvider,
    Tooltip,
    TooltipTrigger,
    TooltipPopup,
    TooltipPopup as TooltipContent,
    TooltipPrimitive,
};
